import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  MenuItem,
  Avatar,
  Grid,
  CardContent,
  useMediaQuery,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Error,
  Close,
  Email,
  Help,
  WebAsset,
  Timeline,
  Equalizer,
  DirectionsBus,
  Payment
} from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { useSnackbar } from "notistack";

import icon from "../../assets/img/logo_white.svg";
import check_balance from "../../assets/svg/check_balance.svg";

import Footer from "./footer.jsx";

import { withLocalize, Translate } from "react-localize-redux";
import { FinanceService } from "../../utils/web_config_2";
import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn: {
    textTransform: "capitalize",
  },
}));


function MaskedCard(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}

      

        mask={[
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/
        ]}

        placeholderChar={"*"}
        showMask={true}
        keepCharPositions={false}
      />
    );
  }


  function TextMaskPhone(props) {
    const { inputRef, ...other } = props;
    
    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }} 
        mask={[
          "6",
          "2",
          "9",
          "2",
          "-",
          "9",
          "5",
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/,
          "-",
          /\d/,
          /\d/,
          /\d/,
          /\d/
        ]}
        placeholderChar={"\u2000"}
        showMask={false}
        keepCharPositions={false}
      />
    );
  }




function CheckBalance(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [accountBalance,setAccountBalance]=useState({});
  const [balanceLoad,setBalanceLoad]=useState(false);
  const [balanceDialog,setBalanceDialog]=useState(false);
  const [cardNumber,setCardNumber]=useState({value:"",error:""});




  useEffect(() => {


  }, []);


  //////// check balance ///////
 

    const checkBalance = () => {
       // validate card\
    //    var testSix="5129-52";
    //    var prodSix="6292-95";
       var cardN=cardNumber.value;

       if(cardN.length==19){

        console.log(cardN);

           setBalanceLoad(true);
           const balanceInstance = axios.create(new FinanceService().setHeadersMicroservice(new FinanceService().TOP_UP_TOKEN));

           balanceInstance.post(new FinanceService().BALANCE+cardN)

      .then(res=>{

        var data=res.data.data;
        
        setAccountBalance(data);
        setBalanceDialog(true);

        setBalanceLoad(false);

      })
      .catch(err=>{

        setBalanceLoad(false);

        if(err?.response){
          enqueueSnackbar(err?.response?.data?.message, {
            variant: "error",
            action: (k) => (
              <IconButton
                onClick={() => {
                  closeSnackbar(k);
                }}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          });
        }else{
          enqueueSnackbar(err?.message, {
            variant: "error",
            action: (k) => (
              <IconButton
                onClick={() => {
                  closeSnackbar(k);
                }}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          });
        }

      });

       }else{
           setCardNumber({value:"",error:"Invalid card number"});
       }
    };

    // format money 

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* balance Dialogs---------------------- */}
      <Dialog
        open={balanceDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() =>{

            setBalanceDialog(false);
            setAccountBalance({});
            setCardNumber({value:"",error:""});

        } }
      >
        <DialogTitle id="alert-dialog-title">
          Your balance
        </DialogTitle>
        {(
          <DialogContent>
            
            <Box mt={2}>
       <List component="nav" aria-label="balances">
        <ListItem>
          <ListItemIcon>
            <Payment />
          </ListItemIcon>
          {fullScreen==false&&<ListItemText primary="Current Balance" />}
          <ListItemSecondaryAction>
          <Typography><b>{formatMoney(accountBalance.current_balance,0)} RWF</b></Typography>
          </ListItemSecondaryAction>

        </ListItem>
        {/* <ListItem>
          <ListItemIcon>
            <Payment />
          </ListItemIcon>
          <ListItemText primary="Openning balance" />
          <ListItemSecondaryAction>
          <Typography><b>{formatMoney(accountBalance.opening_balance,0)} RWF</b></Typography>
          </ListItemSecondaryAction>

        </ListItem> */}
        {/* <ListItem>
          <ListItemIcon>
            <Payment />
          </ListItemIcon>
          <ListItemText primary="Closing balance" />
          <ListItemSecondaryAction>
          <Typography><b>{formatMoney(accountBalance.closing_balance,0)} RWF</b></Typography>
          </ListItemSecondaryAction>

        </ListItem> */}

      </List>
    
            </Box>
         
         </DialogContent>
        )}


        <DialogActions>
          <Button
            onClick={() => {
            setBalanceDialog(false);
            setAccountBalance({});
            setCardNumber({value:"",error:""});
            }}
            variant="outlined"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------------- */}
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar>
          <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>
          <Typography variant="h5" className={classes.title}>
            Check Balance
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={5}>
          <Box p={2} display="flex" flexDirection="column">
            <img
              src={check_balance}
              style={{ height: 300 }}
              alt="Cards showcase"
            />
            <Box
              mb={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            ></Box>
            <Typography color="textSecondary" align="center">
              Enter your card number, Please fulfil last 10 digits.
            </Typography>
          </Box>
          <Box mt={3}>

          <TextField
          id="standard-basic"
                    size="small"
                    color="primary"
                    type="text"
                    value={cardNumber.value}
                    placeholder={"Card Number"}
                    label={"Card Number"}
                    fullWidth
                    onChange={(e)=>{
                      setCardNumber({value:e.target.value,error:""});
                        
                    }}
                    helperText={cardNumber.error}
                    error={cardNumber.error !== ""}
                    InputProps={{
                      inputComponent: TextMaskPhone,
                    }}
                  />

          {/* <FormControl fullWidth variant="outlined" error={cardNumber.error != ""}>
              <Input

                startAdornment={
                    <Typography>
                    6292-95
                    </Typography>
                }

              endAdornment={
                <InputAdornment position="end">
                 <img
              src={icon}
              style={{ height: 30 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
                </InputAdornment>
              }
                onChange={(e)=>{
                  setCardNumber({value:e.target.value,error:""});
                    
                }}
                value={cardNumber.value}
                color="primary"
                varient="outlined"
                inputComponent={MaskedCard}
              />
              <FormHelperText id="code">{cardNumber.error}</FormHelperText>
            </FormControl>
           */}
          </Box>

          <Box mt={2} mb={2}>
            <Button
              disabled={balanceLoad}
              color="primary"
              fullWidth
              variant="contained"
              disableElevation
              onClick={() => {
                checkBalance();
              }}
              className={classes.btn}
            >
              {balanceLoad? <CircularProgress size={23} /> : "get balance"}
            </Button>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Grid container justify="center" alignContent="center" >
          <Grid item xs={12} sm={4} md={3} >
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2} mt={8}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2} mt={8}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2} mt={8}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
}

export default withLocalize(CheckBalance);
